import axios from "axios";

const apiUrl = process.env.REACT_APP_LA_USINA_API_URL;

const api = axios.create({
    baseURL: apiUrl,
    headers: {
        'Content-Type': 'application/json',
    }
});

function readCurrentUser() {
    // H2: si el item está corrupto, no rompemos todas las requests.
    try {
        return JSON.parse(localStorage.getItem("currentUser"));
    } catch (e) {
        localStorage.removeItem("currentUser");
        return null;
    }
}

api.interceptors.request.use((config) => {
    const currentUser = readCurrentUser();
    if (currentUser?.token) {
        // H1: backend usa passport-jwt; conservamos compatibilidad enviando el token crudo.
        // El extractor del backend acepta el header literal. Si en el futuro se cambia a
        // ExtractJwt.fromAuthHeaderAsBearerToken(), añadir el prefijo "Bearer ".
        config.headers.Authorization = currentUser.token;
    }
    return config;
}, (error) => {
    return Promise.reject(error);
});

// H4: interceptor de respuesta para detectar 401 globalmente.
api.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error?.response?.status === 401) {
            localStorage.removeItem("currentUser");
            // No forzamos redirect (sólo limpiamos sesión); los guards de routes.js se encargan.
        }
        return Promise.reject(error);
    }
);

export default api;